<template>

    <v-row class="fill-height">
        <v-col>

            <v-card>

                <v-card-title>
                    <v-icon left>mdi-camera-image</v-icon>
                    Banners
                    <v-spacer></v-spacer>
                    <span></span>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" xl="12" md="12" sm="12" xs="12" class="text-center text-h4">

                            <v-card>
                                <v-card-title primary-title class="justify-center">
                                    Gerencie os banners que serão exibidos na sua página no nosso aplicativo
                                </v-card-title>
                            </v-card>
                        </v-col>

                    </v-row>
                    <v-row>
                        <input v-show="false" ref="inputUpload" type="file"
                               v-on:change="previewImage">

                        <v-col cols="12" xl="4" md="6" sm="12" xs="12" align="center"
                               justify="center" v-for="(banner, index) in banners" :key="'banner'+index">
                            <v-card justify="center" align="center">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">

                                        <v-img v-bind:src="banner.image"
                                               style="background:#E1E1E1 !important;"
                                               max-width="640"
                                               max-height="360"
                                               :aspect-ratio="16/9"
                                               contain
                                               v-bind="attrs"
                                               v-on="on"
                                               align="center">
                                            <span v-show="!banner.id" class="btn-lyndus text-h6 mt-3 pt-2">
                                                Imagem não Cadastrada
                                            </span>
                                        </v-img>

                                    </template>
                                    <span>Fundo cinza para referência. <br>Recomendamos imagem de 640px por 340px (16/9)</span>
                                </v-tooltip>
                                <v-divider class="mt-1"></v-divider>
                                <v-card-actions>
                                    <v-btn
                                        color="red"
                                        outlined
                                        @click="preRemoveBanner(index, banner)">
                                        <v-icon left>mdi-minus-circle-outline</v-icon>
                                        Remover
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="purple"
                                        outlined
                                        @click="imageLoad(index, banner)">
                                        <v-icon left>mdi-image-edit</v-icon>
                                        Alterar
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-col>

                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>

        <confirm-dialog
            :dialog="dialogRemove"
            :title="`Apagar Banner`"
            body="Tem certeza que deseja realizar essa ação?"
            @dialog-event="removeBanner">
        </confirm-dialog>

    </v-row>
</template>

<script>
import {mapGetters} from "vuex";
import {mask} from "vue-the-mask";
import ConfirmDialog from '@/components/ConfirmDialog'

import store from "@/store";

import {CHANGE_PROGRESS} from "@/store/mutations/mutations.type";


import {BANNER_DELETE, BANNER_GET, BANNERS_GET} from "@/store/actions/banner.type";
import {BANNER_RESET_STATE, REMOVE_BANNER, SET_BANNER_INDEX} from "@/store/mutations/banner.type";
import {BannerService} from "@/common/api/banner.service";
import {resizeImage} from "@/common/image.service";

export default {
    name: "Profile",
    directives: {mask},
    components: {ConfirmDialog},
    async beforeRouteUpdate(to, from, next) {
        // Reset state if user goes from /editor/:id to /editor
        // The component is not recreated so we use to hook to reset the state.
        await this.$store.commit(BANNER_RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        await store.commit(BANNER_RESET_STATE);
        await store.dispatch(BANNERS_GET);

        return next();
    },
    data: () => ({
        textRules: [
            v => !!v || "Este campo é obrigatório"
            //v => v > 0 || "Esta campo deve ter um valor maior que zero."
        ],
        formIsValid: false,
        active: false,

        dialogRemove: false,

        localBanner: null,
        indexBanner: null,

    }),
    methods: {

        removeBanner(status) {
            this.dialogRemove = false
            if (!status) {
                return
            }
            this.$store.commit(CHANGE_PROGRESS, true)

            this.$store
                .dispatch(BANNER_DELETE, this.localBanner.id)
                .then(() => {
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "success";
                    this.snackbar.text = "Removido com sucesso";
                    this.$store.commit(REMOVE_BANNER, this.indexBanner)

                    this.localBanner = null
                    this.indexBanner = null
                })
                .catch(({response}) => {
                    this.$store.commit(CHANGE_PROGRESS, false)
                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao remover.";
                    // console.log(response.data);
                    if (typeof response.data.message !== "undefined") {
                        this.snackbar.text = response.data.message;
                    }
                });
        },

        preRemoveBanner(index, banner) {
            this.indexBanner = index;
            this.localBanner = banner;
            this.dialogRemove = true;
        },

        imageLoad(index, banner) {
            this.indexBanner = index;
            this.localBanner = banner;
            this.$refs.inputUpload.click()
        },

        async previewImage(img) {

            if (img.target.files[0]) {
                this.$store.commit(CHANGE_PROGRESS, true)
                resizeImage({
                    file: img.target.files[0],
                    maxWidth: 640,
                    maxHeight: 360
                }).then((imageFile) => {

                    if (typeof this.localBanner.id != 'undefined' && this.localBanner.id) {
                        BannerService.update(this.localBanner.id, imageFile).then((resp) => {

                            this.$store.commit(CHANGE_PROGRESS, false)

                            this.snackbar.snackbar = true;
                            this.snackbar.color = "success";
                            this.snackbar.text = "Salvo com sucesso";

                            if (resp.data.id) {
                                this.$store.commit(SET_BANNER_INDEX, {
                                    index: this.indexBanner,
                                    obj: {id: resp.data.id, image: URL.createObjectURL(imageFile)}
                                });
                            }
                            this.localBanner = null
                            this.indexBanner = null

                        }).catch(({response}) => {
                            this.$store.commit(CHANGE_PROGRESS, false)

                            this.snackbar.snackbar = true;
                            this.snackbar.color = "error";
                            this.snackbar.text = "Erro ao Salvar.";

                            if (typeof response.data.message !== "undefined") {
                                this.snackbar.text =
                                    "Erro ao Salvar: " +
                                    response.data.message;
                            }
                        });
                    } else {
                        BannerService.create(imageFile).then((resp) => {

                            this.$store.commit(CHANGE_PROGRESS, false)

                            this.snackbar.snackbar = true;
                            this.snackbar.color = "success";
                            this.snackbar.text = "Salvo com sucesso";

                            if (resp.data.id) {
                                this.$store.commit(SET_BANNER_INDEX, {
                                    index: this.indexBanner,
                                    obj: {id: resp.data.id, image: URL.createObjectURL(imageFile)}
                                });
                            }
                            this.localBanner = null
                            this.indexBanner = null

                        }).catch(({response}) => {
                            this.$store.commit(CHANGE_PROGRESS, false)

                            this.snackbar.snackbar = true;
                            this.snackbar.color = "error";
                            this.snackbar.text = "Erro ao Salvar.";

                            if (typeof response.data.message !== "undefined") {
                                this.snackbar.text =
                                    "Erro ao Salvar: " +
                                    response.data.message;
                            }
                        });
                    }
                }).catch(function (err) {
                    console.log(err)
                    this.$store.commit(CHANGE_PROGRESS, false)

                    this.snackbar.snackbar = true;
                    this.snackbar.color = "error";
                    this.snackbar.text = "Erro ao Salvar.";

                });
            }
        },

    },
    mounted() {
        for (let i = 0; i < this.banners.length; i++) {
            if (this.banners[i].id) {
                this.$store.dispatch(BANNER_GET, {index: i, id: this.banners[i].id})
            }
        }
    },
    computed: {
        ...mapGetters(["snackbar", "banners"])
    }
};
</script>

<style scoped>
.gridSys {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
}

.grid-2-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
}
</style>
